import { isPlanningPage, profileStepFor } from "../services/onboardingNavigation.js";
export const redirectOnboardingRequired = (error, location = window.location) => {
  if (
    error.response?.status === 409 &&
    error.response.data?.code === "ERROR_CODE_ONBOARDING_REQUIRED" &&
    isPlanningPage(location.pathname) &&
    /\/(financial_freedom(?:\/|_|$)|create_financial_freedom_goal|goal_calculator|emergency_fund|wishlist\/|get_suggested_monthly_savings|calculate_goal_achieve_date|calculator\/financial-freedom)/.test(error.config?.url || "") &&
    !["/on-boarding/on-boarding", "/on-boarding/on-boarding.html"].includes(location.pathname)
  ) {
    location.href = profileStepFor(location.pathname + (location.search || ""));
  }
};
